import { cn } from "../../../lib/cn";

/**
 * AreaChip — chip pequeño con color de área (paleta funcional v2.5).
 *
 * Equivalente a Badge pero con la paleta `area-*` y radio pill.
 * Usar para clasificar entidades, no para decorar.
 */

const AREA_STYLES = {
  intranet:      "bg-area-intranet-bg text-area-intranet-fg",
  hardware:      "bg-area-hardware-bg text-area-hardware-fg",
  software:      "bg-area-software-bg text-area-software-fg",
  accesos:       "bg-area-accesos-bg text-area-accesos-fg",
  conectividad:  "bg-area-conectividad-bg text-area-conectividad-fg",
  instalaciones: "bg-area-instalaciones-bg text-area-instalaciones-fg",
  rrhh:          "bg-area-rrhh-bg text-area-rrhh-fg",
  otros:         "bg-area-otros-bg text-area-otros-fg",
};

export function AreaChip({ area = "otros", icon, children, className }) {
  return (
    <span className={cn(
      "inline-flex items-center gap-1 px-2.5 py-0.5 rounded-pill",
      "text-[11px] font-medium tracking-tight",
      AREA_STYLES[area] ?? AREA_STYLES.otros,
      className,
    )}>
      {icon}
      {children}
    </span>
  );
}
